import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McdPymtProgressChart = ({ formValues, endDateToStartDate }) => {
  const { invPeriodId, stateIds, ctrtIds, checkRunDates } = formValues;

  const { navigateTo } = useNavState();
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!invPeriodId) return;

    const endDate = Math.max(...checkRunDates);
    const minEndDate = Math.min(...checkRunDates);
    const startDate = endDateToStartDate[minEndDate];
    const reqParam = {
      periodId: invPeriodId,
      stateIds,
      ctrtIds,
      startDate,
      endDate,
    };
    rsrc.data('sc', 'MCD_INV_STLMNT_PROGRESS_CHART_DATA_PLUGIN', reqParam).then((data) => {
      setData(data);
    });
  }, [invPeriodId, stateIds, ctrtIds, checkRunDates]);

  const navigateToStlmntList = (dataPoint) => {
    const pymtIds = dataPoint.pymtIds;
    if (!pymtIds || pymtIds.length === 0) return;
    const expr = ExprUtils.setExpr('id', pymtIds);
    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };
    navigateTo('sc/pymt/mcd', navState);
  };

  if (!data) return null;

  return <PieChart data={data} onClick={navigateToStlmntList} />;
};
